import { render } from "./LemonadeTitcher.vue?vue&type=template&id=6a4b3b8a"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/LemonadeTitcher.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a4b3b8a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a4b3b8a', __exports__)) {
    api.reload('6a4b3b8a', __exports__)
  }
  
  module.hot.accept("./LemonadeTitcher.vue?vue&type=template&id=6a4b3b8a", () => {
    api.rerender('6a4b3b8a', render)
  })

}


export default __exports__